export default "__VITE_ASSET__Ws7bWR93__"